import type { SupportingMethod } from '../types.js';
import { typicalPrice } from '../utils.js';

export const sessionVwap: SupportingMethod = ({ candles, direction }) => {
  if (candles.length < 20 || direction === 'neutral') {
    return { id: 'VF-004', name: 'Session VWAP', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candles or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const latest = candles[candles.length - 1]!;
  const utcDay = new Date(latest.openTime).toISOString().slice(0, 10);
  const session = candles.filter((c) => new Date(c.openTime).toISOString().slice(0, 10) === utcDay);
  const firstDay = new Date(candles[0]!.openTime).toISOString().slice(0, 10);
  if (firstDay !== utcDay || session.length < 5) {
    return { id: 'VF-004', name: 'Session VWAP', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'The loaded history does not contain the full current UTC session; VWAP was not scored from a partial session.', dataSufficient: false, sampleSize: candles.length };
  }
  let pv = 0;
  let volume = 0;
  for (const candle of session) {
    pv += typicalPrice(candle) * candle.volume;
    volume += candle.volume;
  }
  if (volume <= 0) {
    return { id: 'VF-004', name: 'Session VWAP', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Session volume is unavailable.', dataSufficient: false, sampleSize: candles.length };
  }
  const vwap = pv / volume;
  const previous = session.at(-2);
  const previousTypical = previous ? typicalPrice(previous) : latest.open;
  const currentAbove = latest.close > vwap;
  const previousAbove = previousTypical > vwap;
  const aligned = direction === 'long' ? currentAbove && !previousAbove : !currentAbove && previousAbove;
  const holding = direction === 'long' ? latest.close > vwap && previousTypical > vwap : latest.close < vwap && previousTypical < vwap;
  return {
    id: 'VF-004',
    name: 'Session VWAP',
    status: 'experimental',
    authority: 1,
    rawSignal: aligned || holding ? 1 : 0,
    contribution: aligned || holding ? 1 : 0,
    direction,
    finding: aligned ? `Price reclaimed the session VWAP in the Core ${direction} direction.` : holding ? `Price is holding ${direction === 'long' ? 'above' : 'below'} session VWAP.` : `Price is not currently aligned with session VWAP for ${direction}.`,
    dataSufficient: true,
    sampleSize: session.length,
  };
};
